// (c) 2023 ABBYY Development, Inc.

export const AGENT_STATUS = {
    ONLINE: 'Online',
    OFFLINE: 'Offline',
    UNHEALTHY: 'Unhealthy'
} as const;

export type AgentStatus = typeof AGENT_STATUS[keyof typeof AGENT_STATUS];
